<template>
<div class="mini-cart-pane bg-white" v-if="show">
    <div class="mini-cart-pane__list">
        <MiniCartItem :item="item" :key="i" v-for="item, i in $store.state.site_data.session.cart.items" />
    </div>
    <div class="mini-cart-pane__summary column">
        <table class="table is-fullwidth is-marginless">
            <tbody>
                <tr>
                    <td>
                        {{$store.state.site_data.session.cart.count}} item<template v-if="$store.state.site_data.session.cart.count > 1">s</template>
                    </td>
                    <td class="has-text-right">
                        {{$store.state.site_data.session.cart.amount.toDollar()}}
                    </td>
                </tr>
                <tr>
                    <td>Shipping</td>
                    <td class="has-text-right">to be quoted</td>
                </tr>
                <tr>
                    <td></td>
                    <td class="has-text-right"></td>
                </tr>
                <tr>
                    <td>GST</td>
                    <td class="has-text-right">{{$store.state.site_data.session.cart.gst.toDollar()}}</td>
                </tr>
                <tr>
                    <td>Total (gst incl.)</td>
                    <td class="has-text-right">{{$store.state.site_data.session.cart.grand_total.toDollar()}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="mini-cart-pane__actions has-text-right column">
        <router-link to="/cart" class="button is-primary">View Cart</router-link>
    </div>
</div>
</template>

<script>
import MiniCartItem from './MiniCartItem';
export default {
    name        :   'MiniCartDetails',
    props       :   ['site_data'],
    components  :   { MiniCartItem },
    data()
    {
        return {
            show        :   false
        };
    },
    watch       :   {
        show(nv, ov) {
            if (nv) {
                $(window).unbind('mousedown', this.click_to_close).on('mousedown', this.click_to_close);
            } else {
                $(window).unbind('mousedown', this.click_to_close);
            }
        }
    },
    created()
    {
        this.$bus.$on('onToggleCart', () => {
            this.show   =   !this.show;
        });
    },
    methods     :   {
        click_to_close: function(e) {
            let target = $(e.target);
            if (!target.is('.mini-cart-pane') &&
                target.parents('.mini-cart-pane').length == 0 &&
                !target.is('.mini-cart__button') &&
                target.parents('.mini-cart__button').length == 0) {
                this.show   =   false;
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/MiniCartDetails.vue